"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemPerformance = void 0;
var ItemPerformance = /** @class */ (function () {
    function ItemPerformance(itemPerformance) {
        if (itemPerformance === void 0) { itemPerformance = {}; }
        Object.assign(this, itemPerformance);
    }
    ItemPerformance.itemsPerformanceByStandardFromMicroApp = function (standard, standardHierarchyLevel, itemsPerformance) {
        return (itemsPerformance || []).filter(function (_a) {
            var item = _a.item;
            return item.hasStandardsByHierarchy(standardHierarchyLevel, standard);
        });
    };
    ItemPerformance.calculatePerformance = function (itemsPerformance) {
        var performance = {
            maxScore: 0,
            score: 0,
        };
        (itemsPerformance || []).forEach(function (_a) {
            var maxScore = _a.maxScore, score = _a.score;
            performance.maxScore += maxScore;
            performance.score += score;
        });
        return performance;
    };
    return ItemPerformance;
}());
exports.ItemPerformance = ItemPerformance;
